import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createSlots as _createSlots, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1bbd0c5d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "tree__container"
};
const _hoisted_4 = {
  class: "mg-l--25"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-ic_list"
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  key: 1,
  class: "node_test"
};
const _hoisted_8 = {
  key: 2,
  class: "node_test"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "header"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, /*#__PURE__*/_toDisplayString('FAV Group'), -1));

const _hoisted_12 = {
  class: "right_card"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Playurl", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Information", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "aaadomain", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "aaaport", -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "usertoken", -1));

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "userid", -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "cpspid", -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "effectiveTimeStr", -1));

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CID-PID-MID", -1));

import { useRoute, useRouter } from 'vue-router';
import TagType from '@/views/common/TagType/index.vue';
import { objToArr, parseQueryString } from '@/utils/tools';
import Buttons from '@/components/Buttons/index.vue';
import { getIpMacApi, encryptBy3DesApi, getDeviceIdByActiveCodeApi } from '@/api/live';
import { nextTick, onMounted, watch } from 'vue';
import { useCommon } from '@/store/useCommon';
import { ElTree, ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';
import SearchHeader from './searchHeader.vue';
import NewCommonTable from './newCommonTable.vue';
import { traceLoginApi, testIndexApi, testAgentApi, getSubCategoryApi, getTraceChannelListApi, getHistoryListApi, getFavouritesListApi, getNetAudioList2Api, getSnRecordApi, getAuthinfoApi, getCookieApi } from '@/api/traceDebug';
import InformationDialog from './informationDialog.vue';
import { ProgramTypeObject } from '@/assets/config/dicts';
import XEUties from 'xe-utils';
import { findLabel } from '@/utils/tools.ts'; // 获取favorite列表数据

export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const showPagination = ref(true); //仅在channel列表展示分页器

    const route = useRoute();
    const router = useRouter();
    const isShowAside = ref(true);
    const loading = ref(true);
    const tableContainer = ref(null);
    const tableWarpRef = ref(null);
    const Authenticator = ref(''); //3des加密的密文

    const information = ref({
      aaadomain: '',
      aaaport: '',
      usertoken: '',
      userid: '',
      cpspid: '',
      effectiveTimeStr: '',
      ids: ''
    });
    const logindData = ref();
    const playUrl = ref([]);
    const showLogData = ref([]);
    const netAudioUrl = ref(''); // 接口返回的3id数据及密码

    const iptvRecords = ref({
      cid: '',
      mid: '',
      pid: '',
      securityData: '',
      sn: ''
    });
    const favoriteOptions = ref([{
      label: t('全部'),
      value: ''
    }]);
    const favGroup = ref('');
    const enList = ref([]);
    const selectedChannelIdList = ref([]);
    const selectedChannel = ref([]);
    const tagRef = ref();
    const activeTag = ref(0); //激活的tag标签，默认0:全部

    const operatorList = ref([]); //操作用户列表

    const playHistoryList = ref([]); //tag: history对应的表格数据

    const favoriteList = ref([]);
    const channelData = ref([]); //tag: channel对应的表格数据

    const defaultExpandNodes = ref([]); //默认展开的节点id数组

    const remoteData = ref(); //接口返回的所有channel数据

    const getAuthInfosUrl = ref('');
    const getCookieUrl = ref('');
    const categoryAppType = ref('live'); // 三级分类类型： live || vod 

    const TAG_STATUS = {
      '0': 'Channel',
      '1': 'Favorite',
      '2': 'History'
    };
    const Tags = computed(() => {
      let common = objToArr(TAG_STATUS, 'type', 'name');
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    });
    onMounted(() => {
      useCommon().clearShowLogData();
      getIpMac(); // closeAside()

      loading.value = false;
    }); // 处理点击事件

    const handleTagClick = tag => {
      if (tag.type === 'close') return closeAside();
      activeTag.value = tag.type;
    };

    const handleSelectionChange = row => {
      selectedChannelIdList.value = [];
      selectedChannel.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedChannelIdList.value.push(val.id);
          selectedChannel.value.push(val);
        });
      }
    };

    const searchConfig = ref({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formData: {
        // 双向绑定的数据
        balance: '',
        loginType: 1,
        sn: '',
        mid: '',
        cid: '',
        pid: '',
        clientType: 'AndroidStb',
        iotFlag: 1,
        username: '',
        password: '',
        httpProtocol: 1,
        appversion: '2.0.0',
        activationCode: ''
      }
    });
    const tableConfig = reactive({
      highlightCurrentRow: true,
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: [{
        label: 'Net Audio',
        color: 'green',
        func: () => {
          if (netAudioUrl.value === '') return false;
          dialogObj.title = "Net Audio";
          dialogObj.visible = true;
          let urlParams = parseQueryString(netAudioUrl.value);

          if (urlParams && urlParams.cid == -1) {
            dialogObj.content = '';
          } else {
            getNetAudio();
          }

          dialogObj.mode = 'netAudio';
        }
      }, {
        label: 'ShowLog',
        type: 'primary',
        func: () => {
          dialogObj.title = "Log";
          dialogObj.mode = 'showLog';
          dialogObj.visible = true;
          dialogObj.content = useCommon().$state.showLogData;
        }
      }]
    });
    const columnConfig = reactive({
      columnList: [{
        label: '序号',
        prop: 'no',
        align: 'left',
        width: 100
      }, {
        label: '图片',
        prop: 'image',
        align: 'left',
        width: 120,
        cellSlot: true,
        slotName: 'imageColumn'
      }, {
        label: '频道名称',
        prop: 'name',
        align: 'left',
        width: 200
      }, {
        label: '编码协议',
        prop: 'programtype',
        align: 'left',
        width: 108,
        formatter: value => findLabel(ProgramTypeObject, value)
      }, {
        label: '传输协议',
        prop: 'transferProtocol',
        align: 'left',
        width: 110
      }, {
        label: '语言',
        prop: 'language',
        align: 'left',
        width: 110
      }, {
        label: '国家',
        prop: 'country',
        align: 'left',
        width: 110
      }, {
        label: '显示编号',
        prop: 'showNo',
        align: 'left',
        width: 110
      }, {
        label: '播放等级',
        prop: 'playLevel',
        align: 'left',
        width: 110
      }, {
        label: '卫星参数',
        prop: 'callsign',
        align: 'left',
        width: 110
      }, {
        label: '操作',
        prop: '',
        align: 'left',
        widgetType: 'buttons',
        width: 210,
        fixed: 'right',
        buttonsList: [{
          label: '详情',
          func: data => {
            dialogObj.title = data.name;
            dialogObj.visible = true;
            dialogObj.content = data;
            dialogObj.mode = 'detail';
          }
        }]
      }]
    }); // 分页size变化的回调

    const sizeChange = size => {
      tableConfig.paginationConfig.limit = size;
      let startNum = (tableConfig.paginationConfig.page - 1) * tableConfig.paginationConfig.limit;
      let endNum = tableConfig.paginationConfig.page * tableConfig.paginationConfig.limit;
      channelData.value = remoteData.value.slice(startNum, endNum);
      tableConfig.data = channelData.value;
    }; // 页码变化的回调


    const currentChange = page => {
      tableConfig.paginationConfig.page = page;
      let startNum = (tableConfig.paginationConfig.page - 1) * tableConfig.paginationConfig.limit;
      let endNum = tableConfig.paginationConfig.page * tableConfig.paginationConfig.limit;
      channelData.value = remoteData.value.slice(startNum, endNum);
      tableConfig.data = channelData.value;
    };

    const tableWidth = ref('0px'); // 关闭侧边栏

    const closeAside = () => {
      tagRef.value.activeType = activeTag.value.toString();
      isShowAside.value = !isShowAside.value;

      if (isShowAside.value) {
        // 侧边栏展开则把右边table容器的宽度设置成未展开时的宽度
        tableContainer.value.style.width = tableWidth.value + 'px';
      } else {
        //关闭侧边栏，记录展开时的宽度
        tableWidth.value = tableContainer.value.offsetWidth;
      }
    }; // 获取子品牌直播分类列表


    const treeData = ref([]);
    const treeRef = ref(); // 搜索按钮的回调

    let searchParams = reactive({
      categoryIds: [] //cpspId

    });
    const tagToDataObj = {
      '0': channelData.value,
      '1': favoriteList.value,
      '2': playHistoryList.value
    };

    const handleLogin = async (val, securityData) => {
      if (val.loginType === 1 && val.password === '' || val.loginType === 0 && val.sn === '') return ElMessage({
        type: 'error',
        message: t('请输入用户名密码或SN进行登录')
      }); //每次登录都要重置表单数据

      channelData.value = [];
      tableConfig.data = [];
      playHistoryList.value = [];
      favoriteList.value = [];
      useCommon().clearShowLogData();

      if (val.loginType === 1) {
        //账号密码登录
        let message = '-123289747$' + Math.floor(Math.random() * 9000) + '$' + val.username + '$' + val.username + '$' + useCommon().$state.localIp + '$' + useCommon().$state.mac + '$SV'; // console.log('加密前message',message)

        let key = val.loginType === 1 ? val.username : val.sn;
        let accountType = val.loginType === 1 ? 'account' : 'sn'; // 加密

        await encryptBy3Des(key, message); // 登录
        // 账号密码登录默认3id = -1

        let params = {
          userid: val.username,
          Authenticator: Authenticator.value,
          type: val.clientType,
          iotFlag: val.iotFlag,
          accountType,
          appversion: val.appversion.trim()
        };

        if (val.loginType === 1) {
          params.cid = -1;
          params.pid = -1;
          params.mid = -1;
        }

        if (val.clientType == 'AndroidStb') params.apollo = 1;
        toLogin(params);
      } else if (val.loginType === 0) {
        //SN登录
        let message = '-123289747$' + Math.floor(Math.random() * 9000) + '$' + val.sn + '$' + val.sn + '$' + useCommon().$state.localIp + '$' + useCommon().$state.mac + '$SV';
        let key = val.loginType === 1 ? val.username : val.sn;
        let accountType = val.loginType === 1 ? 'account' : 'sn';
        await encryptBy3Des(key, message);
        await get3IdAndCode(val.sn);
        let params = {
          userid: val.sn,
          Authenticator: Authenticator.value,
          type: val.clientType,
          accountType,
          appStyle: val.appStyle,
          appversion: val.appversion.trim(),
          cid: iptvRecords.value.cid,
          mid: iptvRecords.value.mid,
          pid: iptvRecords.value.pid
        };
        if (val.clientType == 'AndroidStb') params.apollo = 1;
        toLogin(params).then(async res => {
          if (res === 'loginErr') {
            // sn登录如果登录失败，要调get3IdfromSNApi请求3id和stbid，再加密登录
            // 利用iptvRecords.securityData来再次登录
            let securityData = iptvRecords.value.securityData;
            let message = '-123289747$' + Math.floor(Math.random() * 9000) + '$' + securityData + '$' + securityData + '$' + useCommon().$state.localIp + '$' + useCommon().$state.mac + '$SV';
            let key = securityData;
            await encryptBy3Des(key, message);
            let params = {
              userid: val.sn,
              Authenticator: Authenticator.value,
              type: val.clientType,
              accountType,
              appversion: val.appversion.trim(),
              cid: iptvRecords.value.cid,
              mid: iptvRecords.value.mid,
              pid: iptvRecords.value.pid,
              appStyle: val.appStyle
            };
            if (val.clientType == 'AndroidStb') params.apollo = 1;
            toLogin(params);
          }
        });
      } else {
        //激活码登录
        const {
          code,
          data
        } = await getDeviceIdByActiveCodeApi(val.activationCode);

        if (code == 0) {
          let deviceId = data.deviceId;

          if (deviceId && deviceId !== '') {
            let message = '-123289747$' + Math.floor(Math.random() * 9000) + '$' + deviceId + '$' + deviceId + '$' + useCommon().$state.localIp + '$' + useCommon().$state.mac + '$SV';
            let accountType = 'activationCode';
            await encryptBy3Des(deviceId, message);
            let params = {
              userid: val.activationCode,
              Authenticator: Authenticator.value,
              type: val.clientType,
              accountType,
              appversion: val.appversion.trim()
            };
            if (val.clientType == 'AndroidStb') params.apollo = 1;
            toLogin(params);
          }
        }
      }
    }; // 获取sn登录时对应的3id和密码


    const get3IdAndCode = async sn => {
      const {
        code,
        data
      } = await getSnRecordApi({
        sn
      });

      if (code == 0) {
        iptvRecords.value = data;
        information.value.ids = `${data.cid}-${data.pid}-${data.mid}`;
      }
    }; // 重置按钮的回调


    const handleReset = () => {
      searchConfig.value.formData.username = '';
      searchConfig.value.formData.password = '';
      searchConfig.value.formData.sn = '';
      searchConfig.value.formData.cid = '';
      searchConfig.value.formData.mid = '';
      searchConfig.value.formData.pid = '';
    };

    const defaultProps = reactive({
      children: 'children',
      label: 'label',
      isLeaf: "isLeaf" //标记是否为最后一层，isLeaf:true 不显示箭头

    });

    const handleCheck = (data, {
      checkedNodes,
      checkedKeys,
      halfCheckedNodes,
      halfCheckedKeys
    }) => {
      //console.log('data',data)
      console.log('node', checkedNodes); // data:object 勾选的节点数据 
      // checkedNodes:[{}] 勾选节点的数据，单独勾选子节点的时候元素内不会有children属性，出现children属性即有父节点被选中  
      // checkedKeys:[number] 已勾选的节点node-key
      // halfCheckedNodes:array 半勾选的节点数据，一般是父节点的数据
      // halfCheckedKeys:array  半勾选的节点node-key，一般是父节点的key

      const hasParentNode = halfCheckedKeys.length !== 0; //const cid = isVnoAccount?cpspId:sessionStorage.getItem('currentCid') //运营商id
      //searchParams.cpspId = cid

      searchParams.categoryIds = []; // 过滤出子节点，也就是不含childred字段的节点数据

      let filterNodes = checkedNodes.filter(node => !node.children || node.children === null || node.children.length === 0); // 循环遍历子节点请求channel列表

      if (filterNodes && filterNodes.length > 0) {
        channelData.value = [];
        filterNodes.forEach(item => {
          if (item.programListUrl) {
            getTraceChannelList(item.programListUrl, 'live');
          }
        });
      } else {
        //无节点选中
        tableConfig.data = [];
        channelData.value = [];
      }
    }; // 子节点点击事件，获取对应的channelList


    const handleNodeClick = (data, node) => {
      if (node.level === 3) {
        playUrl.value = []; // 三级节点点击时获取channelList数据

        channelData.value = []; // 有programListUrl的是直播，否则为点播

        let tableType = data.programListUrl ? 'live' : 'vod';
        let url = data.programListUrl ? data.programListUrl : data.subCategoryUrl;
        getTraceChannelList(url, tableType);
      }

      if (node.level === 2) {
        categoryAppType.value = node.data.appType.includes('IPTV') ? 'live' : 'vod'; //点击二级分类请求favorite和history

        playHistoryList.value = [];
        favoriteList.value = [];
        setTimeout(() => {
          let params = {
            usertoken: useCommon().$state.traceDebugLoginData.usertoken,
            action: 0,
            videoencryption: node.data.videoencryption,
            cpspid: information.value.cpspid
          };
          getHistoryList(params, node.data.getPlayHistoryUrl, categoryAppType.value);
          getFavouritesList(params, node.data.getFavouritesList, categoryAppType.value);
        }, 1500);
      }
    };

    const onCancel = () => {
      nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString();
      });
      selectedChannel.value = [];
    };

    watch(() => tableConfig.data, newVal => {
      nextTick(() => {
        const columntree = document.querySelector('#columntree');
        columntree.style.maxHeight = tableWarpRef.value.offsetHeight + 'px';
      });
    }); //监听tag变化，变更表单配置

    watch(() => activeTag.value, newVal => {
      //切换tag,playUrl重置
      playUrl.value = [];

      switch (Number(newVal)) {
        case 0:
          // channel列表
          showPagination.value = true;
          tableConfig.data = channelData.value;
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: '图片',
            prop: 'image',
            align: 'left',
            width: 120,
            cellSlot: true,
            slotName: 'imageColumn'
          }, {
            label: '频道名称',
            prop: 'name',
            align: 'left',
            width: 200
          }, {
            label: '编码协议',
            prop: 'programtype',
            align: 'left',
            width: 108,
            formatter: value => findLabel(ProgramTypeObject, value)
          }, {
            label: '传输协议',
            prop: 'transferProtocol',
            align: 'left',
            width: 110
          }, {
            label: '语言',
            prop: 'language',
            align: 'left',
            width: 110
          }, {
            label: '国家',
            prop: 'country',
            align: 'left',
            width: 110
          }, {
            label: '显示编号',
            prop: 'showNo',
            align: 'left',
            width: 110
          }, {
            label: '播放等级',
            prop: 'playLevel',
            align: 'left',
            width: 110
          }, {
            label: '卫星参数',
            prop: 'callsign',
            align: 'left',
            width: 110
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            widgetType: 'buttons',
            width: 220,
            fixed: 'right',
            buttonsList: [{
              label: '详情',
              func: data => {
                dialogObj.title = data.name;
                dialogObj.visible = true;
                dialogObj.content = data;
                dialogObj.mode = 'detail';
              }
            }, {
              label: '播放链接',
              func: async data => {
                // dialogObj.title= data.name
                // dialogObj.visible=true
                // dialogObj.content = data
                // dialogObj.mode = 'detail'
                let httpOrHlsReg = /^(http|https):\/\/[\s\S]+?[^(\.mpd)]$/i;
                let hasHttpOrHls = data.urlobj.some(item => httpOrHlsReg.test(item.playUrl));
                let dashReg = /^(http):\/\/[\s\S]+(\.mpd)$/i;
                let hasDash = data.urlobj.some(item => dashReg.test(item.playUrl));
                let authInfo = '';
                let cookie = '';

                if (hasHttpOrHls) {
                  //请求authinfo
                  let params = {
                    categoryIds: data.categoryid
                  };
                  const res = await getAuthinfoApi(params, getAuthInfosUrl.value, information.value.usertoken);

                  if (res.success) {
                    authInfo = res.data[0].encryptHexString;
                  }
                }

                if (hasDash) {
                  //请求cookie
                  let h = data.urlobj.filter(item => item.dashFlag == 1 || item.dashFlag == 4)[0].cookieUrlParam;
                  let params = {
                    h,
                    categoryId: data.categoryid
                  };
                  const res = await getCookieApi(params, getCookieUrl.value, information.value.usertoken);

                  if (res.playUrl) {
                    cookie = res.cookieType === 'GOOGLE' ? `?${res.SignedCookie}` : '?' + 'CloudFront-Policy=' + res['CloudFront-Policy'] + '&CloudFront-Signature=' + res['CloudFront-Signature'] + '&CloudFront-Key-Pair-Id=' + res['CloudFront-Key-Pair-Id'];
                  }
                }

                let content = data.urlobj.map(item => {
                  if (/^(http|https):\/\/[\s\S]+?[^(\.mpd)]$/ig.test(item.playUrl)) {
                    return item.playUrl.indexOf('?') > -1 ? item.playUrl + authInfo.replace('?', '&') : item.playUrl + authInfo;
                  }

                  if (dashReg.test(item.playUrl)) {
                    return item.playUrl + cookie;
                  } else {
                    return item.playUrl;
                  }
                });
                dialogObj.title = data.name;
                dialogObj.visible = true;
                dialogObj.content = content;
                dialogObj.mode = 'playurl';
              }
            }]
          }];
          break;

        case 1:
          // FAVORITe列表
          // favoriteList.value.forEach(item=> {
          //   playUrl.value.push(item.playurl)
          // })
          showPagination.value = false;
          tableConfig.data = favoriteList.value;
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: '分类',
            prop: 'categoryName',
            align: 'left'
          }, {
            label: '频道名称',
            prop: 'name',
            align: 'left'
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            widgetType: 'buttons',
            fixed: 'right',
            width: 100,
            buttonsList: [{
              label: '详情',
              func: data => {
                dialogObj.title = data.name;
                dialogObj.visible = true;
                dialogObj.content = data;
                dialogObj.mode = 'detail';
              }
            }]
          }];
          break;

        case 2:
          // History列表
          showPagination.value = false;
          tableConfig.data = playHistoryList.value;
          columnConfig.columnList = [{
            label: '序号',
            prop: 'no',
            align: 'left',
            width: 100
          }, {
            label: '分类',
            prop: 'categoryName',
            align: 'left'
          }, {
            label: '频道名称',
            prop: 'mediaName',
            align: 'left'
          }, {
            label: '操作',
            prop: '',
            align: 'left',
            widgetType: 'buttons',
            fixed: 'right',
            width: 100,
            buttonsList: [{
              label: '详情',
              func: data => {
                dialogObj.title = data.name;
                dialogObj.visible = true;
                dialogObj.content = data;
                dialogObj.mode = 'detail';
              }
            }]
          }];
          break;
      }
    }, {
      immediate: true
    }); // 展示信息弹框对象

    const dialogObj = reactive({
      visible: false,
      title: '',
      content: {},
      mode: 'detail'
    }); // 树节点detail点击事件

    const onTreeNodeDetail = treeData => {
      dialogObj.visible = true;
      dialogObj.title = treeData.name;
      dialogObj.content = treeData;
      dialogObj.mode = 'detail';
    }; // 保存本机的ip和mac


    const getIpMac = async () => {
      const {
        code,
        data
      } = await getIpMacApi();

      if (code == 0) {
        useCommon().addIpAndMac(data);
      }
    }; // 3DES加密


    const encryptBy3Des = async (password, plan) => {
      const {
        code,
        data
      } = await encryptBy3DesApi(password, plan);

      if (code == 0) {
        Authenticator.value = data;
      } else {
        console.log('加密报文失败');
      }
    }; // 登录存储接口返回的信息


    const toLogin = async params => {
      // 190703009527 190703009527账号密码用于测试
      // hong6234@126.com 123456
      const res = await traceLoginApi(params);

      if (res.returnCode == 0) {
        information.value.cpspid = res.cpspid;
        information.value.usertoken = res.usertoken;
        information.value.userid = res.userid;
        information.value.effectiveTimeStr = res.effectiveTimeStr;
        logindData.value = res;
        netAudioUrl.value = res.NetAudioUrl ? res.NetAudioUrl : ''; //处理接口返回的3id

        let idsObj = parseQueryString(res.StbQrcodeUrl);

        if (idsObj.cid && searchConfig.value.formData.loginType !== 0) {
          // 非sn登录再使用接口返回的3id
          information.value.ids = idsObj.cid + '- ' + idsObj.pid + '- ' + idsObj.mid;
        } // playHistoryList.value = []
        // favoriteList.value = []


        useCommon().addTraceDebugLoginData(res);

        if (res.AgentUrl) {
          let params = res.AgentUrl + '&usertoken=' + useCommon().$state.traceDebugLoginData.usertoken;
          if (searchConfig.value.formData.clientType == 'AndroidStb') params = params + '&apollo=1'; // 获取一级分类列表，params为url+usertoken

          getCategoryList(params);
        } else {
          console.error('456err,未返回agentUrl');
        }
      } else {
        //sn登录失败，返回'loginErr'字符串，然后判断使用另一种加密登录方式
        if (res.description === 'Invalid password.' && searchConfig.value.formData.loginType === 0) {
          return 'loginErr';
        } else {
          ElMessage({
            type: 'error',
            message: res.description || res.message
          });
        }
      }
    }; // testIndex


    const getSubCategory = async (otherParams, index, parentIndex, nodeData) => {
      //otherParams : {c?:string, pt?: string, live?: string}
      // index tree的节点索引
      let params = {
        usertoken: useCommon().$state.traceDebugLoginData.usertoken,
        type: searchConfig.value.formData.clientType,
        cpspid: useCommon().$state.traceDebugLoginData.cpspid,
        ...otherParams
      };
      const res = await testIndexApi(params, logindData.value.epgdomain);

      if (res) {
        //let copyData = JSON.parse(JSON.stringify(res))
        let copyData = XEUties.clone(res, true); // 把getPlayHistoryUrl，getFavouritesList存储到对应二级节点

        treeData.value[parentIndex].children[index].getPlayHistoryUrl = copyData.getPlayHistoryUrl ? copyData.getPlayHistoryUrl : undefined;
        treeData.value[parentIndex].children[index].getFavouritesList = copyData.getFavouritesList ? copyData.getFavouritesList : undefined; // 存请求上述url要用到的数据

        let obj = copyData.category && copyData.category.length > 0 ? parseQueryString(copyData.category[0].subCategoryUrl) : {
          videoencryption: 0
        };
        treeData.value[parentIndex].children[index].videoencryption = obj.videoencryption; //如果res.category.length>0，则有二级分类,请求该数组中得subCategoryUrl，注意携带usertoken去请求

        if (copyData.category && copyData.category.length > 0) {
          copyData.category.forEach(async item => {
            let urlParams = item.subCategoryUrl + '&usertoken=' + useCommon().$state.traceDebugLoginData.usertoken;
            const responseData = await getSubCategoryApi(urlParams);

            if (responseData.category && responseData.category.length > 0) {
              // 将对应的子节点插入treeData中
              //treeData.value[index].children = responseData.category
              responseData.category.forEach(item => item.isLeaf = true); // 默认第三级节点下无子节点

              treeData.value[parentIndex].children[index].children = XEUties.clone(responseData.category, true);
            }
          });
        }

        getAuthInfosUrl.value = copyData.getAuthInfosUrl;
        getCookieUrl.value = copyData.getCookieUrl;
      } else {
        console.log('testIndexApi异常');
      }
    }; // 拿vod相关的运营方案


    const getVodCategory = async (otherParams, index, parentIndex, nodeData) => {
      let params = {
        usertoken: useCommon().$state.traceDebugLoginData.usertoken,
        type: searchConfig.value.formData.clientType,
        cpspid: useCommon().$state.traceDebugLoginData.cpspid,
        ...otherParams
      };
      const res = await testIndexApi(params, nodeData.epgdomain);

      if (res) {
        //let copyData = JSON.parse(JSON.stringify(res))
        let copyData = XEUties.clone(res, true); // 把getPlayHistoryUrl，getFavouritesList存储到对应二级节点

        treeData.value[parentIndex].children[index].getPlayHistoryUrl = copyData.VodPlusPlayHistoryListUrl ? copyData.VodPlusPlayHistoryListUrl : undefined;
        treeData.value[parentIndex].children[index].getFavouritesList = copyData.VodPlusFavoritesListUrl ? copyData.VodPlusFavoritesListUrl : undefined; // 存请求上述url要用到的数据

        let obj = copyData.category && copyData.category.length > 0 ? parseQueryString(copyData.category[0].subCategoryUrl) : {
          videoencryption: 0
        };
        treeData.value[parentIndex].children[index].videoencryption = obj.videoencryption;
        const url = copyData.VodPlusUrl + '&usertoken=' + useCommon().$state.traceDebugLoginData.usertoken;
        const responseData = await getSubCategoryApi(url);

        if (responseData) {
          responseData.forEach(item => item.isLeaf = true); // 默认第三级节点下无子节点

          treeData.value[parentIndex].children[index].children = XEUties.clone(responseData, true);
        }

        getAuthInfosUrl.value = copyData.getAuthInfosUrl;
        getCookieUrl.value = copyData.getCookieUrl;
      } else {
        console.log('856testIndexApi异常');
      }
    }; // 拿左侧分类列表


    const getCategoryList = async data => {
      const res = await testAgentApi(data);

      if (res && res.length > 0) {
        // 过滤list为空的主品牌,再组合数据
        //let copyData = JSON.parse(JSON.stringify(res))
        let copyData = XEUties.clone(res, true);
        treeData.value = copyData.filter(item => {
          return item.list && item.list.length > 0;
        }).map(item => {
          return { ...item,
            children: item.list ? item.list : []
          };
        });
      }
    }; // 懒加载子节点


    const loadNode = (node, resolve) => {
      if (node.level == 1) {
        // 点击一级节点
        resolve(node.data.children);
      }

      if (node.level == 2) {
        // 点击二级节点，请求index接口，拿三级节点
        let otherParams = parseQueryString(node.data.epgdomain);
        let treeDataIndex = 0;
        let nodeIndex = 0;
        treeData.value.forEach((firstNode, index) => {
          // 一级节点
          if (firstNode.children) {
            firstNode.children.forEach((secondNode, i) => {
              // 二级节点
              if (secondNode.agentName == node.data.agentName) {
                treeDataIndex = index;
                nodeIndex = i; // 这个方法是通过nodeIndex，treeDataIndex两个索引把接口返回的数据插入到treeData中
                // 根据appType区分 vod 、vodPlus 、iptv 、MyLink

                if (node.data.appType.includes('MyLink')) {
                  // mylink不处理，默认没有子节点
                  resolve([]);
                } else if (node.data.appType.includes('IPTV')) {
                  // 直播
                  getSubCategory(otherParams, nodeIndex, treeDataIndex, node.data);
                  categoryAppType.value = 'live';
                } else {
                  // vod || vodPlus
                  getVodCategory(otherParams, nodeIndex, treeDataIndex, node.data);
                  categoryAppType.value = 'vod';
                }
              }
            });
          }
        });
        setTimeout(() => {
          let targetSecondNode = treeData.value[treeDataIndex].children[nodeIndex];

          if (!targetSecondNode.children || targetSecondNode.children.legnth < 0) {
            // 二级节点没有children 如：T.TV Live 节点，则返回空数组
            targetSecondNode.isLeaf = true;
            resolve([]);
          } else {
            // 二级节点有children，则遍历三级节点，没有children则标记isLeaf
            targetSecondNode.children.forEach(item => {
              if (!item.children || item.children.length < 0) {
                item.isLeaf = true;
              }
            });
            resolve(node.data.children);
          }
        }, 2000);
      }
    }; // 过滤playUrl列表拿到传输协议


    const filterTransferProtocol = list => {
      let target = [];
      const p2pReg = /^(butterfly):\/\/[\s\S]+$/i;
      const dashReg = /^(http):\/\/[\s\S]+(\.mpd)$/i;
      const hlsReg = /^(http):\/\/[\s\S]+(\.m3u8)$/i;
      if (!list || list.length === 0) return '';
      list.forEach(item => {
        if (!item.playUrl || item.playUrl === '') {
          target.push('');
        } else if (p2pReg.test(item.playUrl)) {
          target.push('P2P');
        } else if (dashReg.test(item.playUrl)) {
          if (item.dashFlag == 1) {
            target.push('DASH');
          } else {
            //dashFlag==4
            target.push('PDASH');
          }
        } else if (hlsReg.test(item.playUrl)) {
          target.push('HLS');
        } else {
          target.push('HTTP');
        }
      }); //去重

      let result = Array.from(new Set(target.filter(item => item !== ''))).join(',');
      return result === '' ? '--' : result;
    }; // 获取channel列表


    const getTraceChannelList = async (url, type) => {
      // type: vod || live
      const res = await getTraceChannelListApi({
        usertoken: information.value.usertoken,
        start: 0,
        total: 500
      }, url);

      if (res) {
        tableConfig.paginationConfig.limit = 10;
        tableConfig.paginationConfig.page = 1;
        tableConfig.paginationConfig.total = type == 'live' ? res.totalNum : res.length ? res.length : 0;
        remoteData.value = type == 'live' ? res.channel.map((item, index) => {
          return { ...item,
            no: index + 1,
            transferProtocol: filterTransferProtocol(item.urlobj)
          };
        }) : res.map((item, index) => {
          return { ...item,
            no: index + 1
          };
        });
        let startNum = (tableConfig.paginationConfig.page - 1) * tableConfig.paginationConfig.limit;
        let endNum = tableConfig.paginationConfig.page * tableConfig.paginationConfig.limit;
        channelData.value = remoteData.value.slice(startNum, endNum);
      }

      if (activeTag.value == 0) tableConfig.data = channelData.value;
    }; // 更新information的aaaadmain和aaaPort


    const onUpdateDomainPort = (aaadomain, aaaport) => {
      information.value.aaadomain = aaadomain;
      information.value.aaaport = aaaport;
    }; // 获取history表格数据


    const getHistoryList = async (params, url, type) => {
      const res = await getHistoryListApi(params, url);

      if (res.returnCode == 0 && type === 'live') {
        // 直播
        let copyData = XEUties.clone(res, true);

        if (copyData.playInfo && copyData.playInfo.length > 0) {
          copyData.playInfo = copyData.playInfo.map((val, index) => {
            // 根据categoryId找到分类名称
            let targetTreeNode = XEUties.filterTree(treeData.value, item => item.id === val.categoryId);
            return { ...val,
              no: index + 1,
              categoryName: targetTreeNode[0].name
            };
          });
          playHistoryList.value = playHistoryList.value.concat(copyData.playInfo);
        }
      } else {
        // 点播
        let copyData = XEUties.clone(res, true);
        copyData.playInfo = copyData.map((val, index) => {
          let targetTreeNode = XEUties.filterTree(treeData.value, item => item.id === val.categoryid);
          return { ...val,
            no: index + 1,
            mediaName: val.name,
            categoryName: targetTreeNode.length ? targetTreeNode[0].name : ''
          };
        });
        playHistoryList.value = playHistoryList.value.concat(copyData.playInfo);
      }

      if (activeTag.value == 2) tableConfig.data = playHistoryList.value;
    };

    const getFavouritesList = async (params, url, type) => {
      favoriteOptions.value = [{
        label: t('全部'),
        value: ''
      }];
      favoriteList.value = [];
      const res = await getFavouritesListApi(params, url);

      if (res) {
        let copyData = XEUties.clone(res, true);
        copyData.forEach(item => {
          if (item.programlist && item.programlist.length > 0) {
            item.programlist.forEach((val, index) => {
              // 整理数据，programlist每一项加上parentCategoryName,treeCategoryName属性，再push到favoriteList去
              let targetTreeNode = XEUties.filterTree(treeData.value, item => item.id === val.categoryid);
              console.log('targetTreeNode', targetTreeNode);
              val.treeCategoryName = targetTreeNode.length ? targetTreeNode[0].name : '';
              val.no = index + 1;
              val.parentCategoryName = item.categoryname;
              val.name = val.mediaName; // 接口不再返回categoryName  手动添加categoryName

              val.categoryName = targetTreeNode.length ? targetTreeNode[0].name : '';
              favoriteList.value.push(val);
            });
          }

          favoriteOptions.value.push({
            label: item.categoryname,
            value: item.id
          }); // 如果当前激活的选项卡是Favorite，则直接展示favoriteList

          if (activeTag.value == 1) tableConfig.data = favoriteList.value;
        }); // 标签去重

        favoriteOptions.value = uniqueFunc(favoriteOptions.value, 'label');
      }
    }; // 清除showLog数据


    const onClearShowLogData = () => {
      dialogObj.content = [];
    }; // 获取url字符串种parentId的值


    const getParentValue = url => {
      const regex = /[?&]parentId=([^\s&]+)/;
      const match = url.match(regex);

      if (match && match[1]) {
        return match[1]; // 输出 "12"    
      } else {
        console.error("URL 中没有包含查询参数 `parentId`。");
      }
    };
    /*
     *数组对象去重
     */


    const uniqueFunc = (arr, uniId) => {
      const res = new Map();
      return arr.filter(item => !res.has(item[uniId]) && res.set(item[uniId], 1));
    }; // 下拉框change事件


    const onChangeGroup = val => {
      //筛选favoriteList列表
      if (val !== '全部' && favoriteList.value.length > 0) {
        tableConfig.data = favoriteList.value.filter(item => item.treeCategoryName === val);
      } else if (val == '全部') {
        //还原全部的数据
        tableConfig.data = favoriteList.value;
      }
    }; // 表格行被点击，获取playUrl展示在右侧


    const onRowClick = (row, column, event) => {
      playUrl.value = [];

      if (activeTag.value == 0) {
        row.urlobj && row.urlobj.forEach(val => {
          playUrl.value.push(val.playUrl);
        });
      }

      if (activeTag.value == 2) {
        row.playUrl && row.playUrl.forEach(val => {
          playUrl.value.push(val.playUrl);
        });
      }

      if (activeTag.value == 3) {
        playUrl.value.push(row.playurl);
      }
    };
    /** 获取netAudio */


    const getNetAudio = async () => {
      let url = netAudioUrl.value.split('?')[0];
      let params = {
        usertoken: information.value.usertoken,
        cid: iptvRecords.value.cid,
        mid: iptvRecords.value.mid,
        pid: iptvRecords.value.pid,
        userName: searchConfig.value.formData.loginType === 1 ? searchConfig.value.formData.username : searchConfig.value.formData.sn
      };
      const res = await getNetAudioList2Api(params, url);
      dialogObj.content = res;
    }; // 头部搜索触发了loading


    const onLoading = state => {
      loading.value = state;
    };

    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_column = _resolveComponent("column");

      const _component_el_card = _resolveComponent("el-card");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchHeader, {
        modelValue: searchConfig.value.formData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchConfig.value.formData = $event),
        size: searchConfig.value.size,
        onLogin: handleLogin,
        onReset: handleReset,
        onUpdateInformation: onUpdateDomainPort,
        gutter: 50,
        onLoading: onLoading
      }, null, 8, ["modelValue", "size"]), _createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("header", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('栏目列表')), 1), _createElementVNode("span", {
        onClick: closeAside,
        class: "mg-r--25 aside__cursor"
      }, _hoisted_6)]), _createVNode(_unref(ElTree), {
        id: "columntree",
        style: {
          "padding-top": "10px"
        },
        data: treeData.value,
        props: defaultProps,
        "default-expanded-keys": _ctx.defaultExpandedNodes,
        "highlight-current": "",
        onCheck: handleCheck,
        ref_key: "treeRef",
        ref: treeRef,
        "node-key": "value",
        load: loadNode,
        lazy: "",
        onNodeClick: handleNodeClick
      }, {
        default: _withCtx(({
          node,
          data
        }) => [node.level == 1 ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: data.mainAgentLogo,
          fit: "fill",
          style: {
            "width": "33px",
            "height": "23px",
            "margin-right": "5px",
            "position": "absolute",
            "left": "8px"
          }
        }, null, 8, ["src"])) : _createCommentVNode("", true), node.level !== 3 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.agentName ? data.agentName : data.mainAgentName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(data.name), 1)), node.level == 3 ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: "tree_btn",
          onClick: $event => onTreeNodeDetail(data)
        }, _toDisplayString('Detail'), 8, _hoisted_9)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data", "props", "default-expanded-keys"])], 512), [[_vShow, isShowAside.value]]), _createElementVNode("div", {
        class: "table__container",
        ref_key: "tableContainer",
        ref: tableContainer
      }, [_createElementVNode("div", _hoisted_10, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick,
        ref_key: "tagRef",
        ref: tagRef
      }, null, 8, ["modelValue"]), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, null, 8, ["buttons-list"])]), _createElementVNode("div", {
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(NewCommonTable, {
        style: {
          "width": "80%"
        },
        "table-config": tableConfig,
        showPagination: showPagination.value,
        onRowClick: onRowClick,
        "pagination-config": tableConfig.paginationConfig,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: handleSelectionChange
      }, _createSlots({
        rightCard: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_card, {
          style: {
            "margin-bottom": "10px"
          },
          class: "top_card"
        }, {
          default: _withCtx(() => [_hoisted_13, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playUrl.value, (item, index) => {
            return _openBlock(), _createElementBlock("p", {
              key: index
            }, _toDisplayString(item), 1);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_card, {
          class: "bottom_card"
        }, {
          default: _withCtx(() => [_hoisted_14, _createElementVNode("p", null, [_hoisted_15, _createTextVNode(": " + _toDisplayString(information.value.aaadomain), 1)]), _createElementVNode("p", null, [_hoisted_16, _createTextVNode(": " + _toDisplayString(information.value.aaaport), 1)]), _createElementVNode("p", null, [_hoisted_17, _createTextVNode(": " + _toDisplayString(information.value.usertoken), 1)]), _createElementVNode("p", null, [_hoisted_18, _createTextVNode(": " + _toDisplayString(information.value.userid), 1)]), _createElementVNode("p", null, [_hoisted_19, _createTextVNode(": " + _toDisplayString(information.value.cpspid), 1)]), _createElementVNode("p", null, [_hoisted_20, _createTextVNode(": " + _toDisplayString(information.value.effectiveTimeStr), 1)]), _createElementVNode("p", null, [_hoisted_21, _createTextVNode(": " + _toDisplayString(information.value.ids), 1)])]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          imageColumn: _withCtx(scope => [_createVNode(_component_el_image, {
            style: {
              "width": "50px",
              "height": "50px"
            },
            src: scope.row.image,
            fit: _ctx.fit
          }, null, 8, ["src", "fit"])]),
          _: 1
        }, 8, ["column-list"])]),
        _: 2
      }, [activeTag.value == 1 ? {
        name: "tableHeader",
        fn: _withCtx(() => [_hoisted_11, _createVNode(_component_el_select, {
          modelValue: favGroup.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => favGroup.value = $event),
          placeholder: "",
          style: {
            "margin-bottom": "10px"
          },
          onChange: onChangeGroup
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteOptions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.label
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])
      } : undefined]), 1032, ["table-config", "showPagination", "pagination-config"])], 512)], 512)]), _createVNode(InformationDialog, {
        modelValue: dialogObj.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogObj.visible = $event),
        title: dialogObj.title,
        content: dialogObj.content,
        onClearShowLogData: onClearShowLogData,
        mode: dialogObj.mode
      }, null, 8, ["modelValue", "title", "content", "mode"])])), [[_directive_loading, loading.value]]);
    };
  }

});